import { getSMDeviceId } from './fp';
import BsUtil from '../BsUtil';

async function getDeviceId(){
    let deviceId = BsUtil.getCookie('deviceId')
    if(deviceId){
        return deviceId;
    }
    return new Promise((resolve,reject)=>{
        try {
            let timer = setTimeout(()=>{
                resolve('');
                clearTimeout(timer);
                timer = null;
            },1000);
            getSMDeviceId().then(function (deviceId) {
                if(deviceId) BsUtil.setCookie('deviceId', deviceId, 365);
                resolve(deviceId);
                clearTimeout(timer);
            });
        } catch (error) {
            resolve('');
        }
    })
}


var hasGetDeviceId = getDeviceId();

export default function (){
  return hasGetDeviceId
}
